"use strict";
import { __module as e } from "./index.es163.js";
import { __require as t } from "./index.es164.js";
import { __require as i } from "./index.es165.js";
var r;
function m() {
  return r ? e.exports : (r = 1, process.env.NODE_ENV === "production" ? e.exports = t() : e.exports = i(), e.exports);
}
export {
  m as __require
};
//# sourceMappingURL=index.es162.js.map
